import { IComplianceChecks, User } from './User';

export interface IGenerateQrResponse {
  token: string;
  encodedToken: string;
  secondsToExpire: number;
}

export interface ISuccessLogin {
  accessToken: string;
  complianceChecks: IComplianceChecks;
  refreshToken: string;
  user: User;
}

export enum RAMP_MODE {
  ON,
  OFF,
}
